export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-18.jpg'),
        title: 'ネットワークセキュリティ',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'ネットワークセキュリティは企業運営に不可欠です',
      description: `<p style="font-size:1.05rem">インターネット時代において、ネットワークセキュリティは事業運営にとって非常に重要です。ネットワークシステムのハードウェア、ソフトウェア、データが偶発的または悪意によって改ざん・破壊・漏洩されないように保護し、セキュリティシステムを連続的かつ信頼性高く稼働させることが必要です。それによりネットワークサービスの中断を防ぎます。</p>
<p>MaesInfoは優秀なJavaエンジニアや上級ソフトウェア開発者、Cisco/CCIEレベルのネットワーク専門家を擁し、ソフトウェアセキュリティ、運用サービスセキュリティ、データセキュリティなど包括的な専門サービスを提供します。</p>`
    },
    {
      title: 'MaesInfoが提供できること：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-18.jpg')+`)"></span>
      <span class="list">
      <i></i>ネットワークセキュリティ保護ソフトの開発・アップグレード<br/>
      <i></i>データ漏洩や改ざんを防ぐための保護システムの更新・強化

      </span>`
    }
  ]
}
